import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Member Statistics"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Over 500 new members")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-300px rounded-start" }, "Agent"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "Earnings"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "Comission"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Company"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Rating"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px text-end rounded-end" })
  ])
], -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "symbol symbol-50px me-5" }
const _hoisted_12 = { class: "symbol-label bg-light" }
const _hoisted_13 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_14 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_15 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_16 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_17 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_18 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_19 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_20 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_21 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_22 = { class: "rating" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_24 = { class: "text-muted fw-bold text-muted d-block fs-7 mt-1" }
const _hoisted_25 = /*#__PURE__*/_createVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2"
  }, " View "),
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4"
  }, " Edit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown2 = _resolveComponent("Dropdown2")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown2)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("table", _hoisted_8, [
          _hoisted_9,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("span", _hoisted_12, [
                        _createVNode("img", {
                          src: item.agent.image,
                          class: "h-75 align-self-end",
                          alt: ""
                        }, null, 8, ["src"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("a", _hoisted_14, _toDisplayString(item.agent.name), 1),
                      _createVNode("span", _hoisted_15, _toDisplayString(item.agent.skills), 1)
                    ])
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_16, _toDisplayString(item.earnings.value), 1),
                  _createVNode("span", _hoisted_17, _toDisplayString(item.earnings.remarks) + ">", 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_18, _toDisplayString(item.comission.value), 1),
                  _createVNode("span", _hoisted_19, _toDisplayString(item.comission.remarks), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_20, _toDisplayString(item.company.name), 1),
                  _createVNode("span", _hoisted_21, _toDisplayString(item.company.fields), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_22, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (i) => {
                      return _createVNode("div", {
                        key: i,
                        class: [[item.rating.value >= i && 'checked'], "rating-label me-2"]
                      }, [
                        _hoisted_23
                      ], 2)
                    }), 64))
                  ]),
                  _createVNode("span", _hoisted_24, _toDisplayString(item.rating.remarks), 1)
                ]),
                _hoisted_25
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}